import { Navigate, Outlet } from "react-router-dom";

export default function AuthenticatedRedirectRoute({
    hasUser,
    redirectPath = '/',
    children,
}) {
    if (hasUser) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;
};